/**
 * Fetches a configuration value by name.
 */
export function fetch(name) {
  // using thunk middleware, so we return a function
  return (dispatch) => {
    // make the call
    return dispatch({
      type: 'FETCH_CONFIG',
      payload: {
        request: {
          method: 'get',
          url: `/config/${name}`,
        },
      },
    }).then((response) => {
      return response;
    });
  };
}
